import {
  BellIcon,
  CableIcon,
  CreditCardIcon,
  KeyRoundIcon,
  MonitorSmartphone,
  SettingsIcon,
  ShieldCheck,
} from 'lucide-react'

export enum SettingTab {
  GENERAL = 'GENERAL',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SECURITY = 'SECURITY',
  DEVICES = 'DEVICES',
  API = 'API',
  BILLING = 'BILLING',
  ACCOUNT = 'ACCOUNT',
}

export const SETTING_TAB = [
  {
    id: SettingTab.GENERAL,
    label: 'General',
    icon: SettingsIcon,
  },
  {
    id: SettingTab.NOTIFICATIONS,
    label: 'Notifications',
    icon: BellIcon,
  },
  {
    id: SettingTab.SECURITY,
    label: 'Security',
    icon: ShieldCheck,
  },
  {
    id: SettingTab.DEVICES,
    label: 'Devices',
    icon: MonitorSmartphone,
  },
  {
    id: SettingTab.API,
    label: 'API',
    icon: KeyRoundIcon,
  },
  {
    id: SettingTab.BILLING,
    label: 'Billing',
    icon: CreditCardIcon,
  },
  {
    id: SettingTab.ACCOUNT,
    label: 'Accounts',
    icon: CableIcon,
  },
]
